// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #0f0e17;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
}

.hero {
  color: #ff8906;
  font-family: "Matemasie", sans-serif;
  font-size: 3rem;
}

.picture-strip {
  width: 155rem;
  height: 35.5rem;
  display: flex;
  justify-content: center;
}

.picture-frame {
  width: 31rem;
  height: 35.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.picture {
  width: 24rem;
  height: auto;
}

.picture-frame {
  display: none;
}

.navigation-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.navigation {
  width: 3rem;
  height: auto;
  cursor: pointer;
  transition: filter 0.15s ease-out;
}

.navigation:hover {
  filter: drop-shadow(0.1rem 0.1rem 0.7rem #e53170)
    drop-shadow(-0.1rem -0.1rem 0.7rem #e53170);
}

.slides-tracker {
  width: 9rem;
  height: 1rem;
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.slide {
  height: 0.5rem;
  width: 0.5rem;
  cursor: pointer;
  opacity: 0.5;
  background-color: #ff8906;
  border-radius: 50%;
  transition: transform 0.1s ease-out, opacity 0.1s ease-out;
}

.slide:hover {
  transform: scale(2);
  opacity: 1;
}

.active-slide {
  transform: scale(2);
  opacity: 1;
}

.visibility {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE;+CAC6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf","sourcesContent":["body {\n  background-color: #0f0e17;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.hero {\n  color: #ff8906;\n  font-family: \"Matemasie\", sans-serif;\n  font-size: 3rem;\n}\n\n.picture-strip {\n  width: 155rem;\n  height: 35.5rem;\n  display: flex;\n  justify-content: center;\n}\n\n.picture-frame {\n  width: 31rem;\n  height: 35.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.picture {\n  width: 24rem;\n  height: auto;\n}\n\n.picture-frame {\n  display: none;\n}\n\n.navigation-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.navigation {\n  width: 3rem;\n  height: auto;\n  cursor: pointer;\n  transition: filter 0.15s ease-out;\n}\n\n.navigation:hover {\n  filter: drop-shadow(0.1rem 0.1rem 0.7rem #e53170)\n    drop-shadow(-0.1rem -0.1rem 0.7rem #e53170);\n}\n\n.slides-tracker {\n  width: 9rem;\n  height: 1rem;\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  align-items: center;\n}\n\n.slide {\n  height: 0.5rem;\n  width: 0.5rem;\n  cursor: pointer;\n  opacity: 0.5;\n  background-color: #ff8906;\n  border-radius: 50%;\n  transition: transform 0.1s ease-out, opacity 0.1s ease-out;\n}\n\n.slide:hover {\n  transform: scale(2);\n  opacity: 1;\n}\n\n.active-slide {\n  transform: scale(2);\n  opacity: 1;\n}\n\n.visibility {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
